import { getApi } from 'apis';
import TableActionHeader from 'components/Global/TableActionHeader';
import { useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import { SideDrawerWrapper } from '../../../../src/components/Global';
import PermissionBody from './PermissionBody';
import DynamicTable from './Table';
import styles from './index.module.scss';

const RoleTable = () => {
	const [drawerAnimation, setDrawerAnimation] = useState<boolean>(false);
	const [selectedRole, setSelectedRole] = useState<any>(null);
	const [isPermissionDrawerOpen, setIsPermissionDrawerOpen] =
		useState<boolean>(false);
	const [drawerInfo, setDrawerInfo] = useState({
		drawerTitle: 'Add Role',
	});

	const [permissions, setPermissions] = useState([]);
	const [roles, setRoles] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	// Remove from drawer handler
	const removeDrawerFromDom = () => {
		setIsPermissionDrawerOpen(false);
	};

	// For open the sideDrawer with animation
	const openPermissionsHandler = () => {
		setDrawerAnimation(true);
		setIsPermissionDrawerOpen(true);
	};
	// For perform the close animation
	const closeDrawerByAnimation = () => {
		setDrawerAnimation(false);
		setPermissions([]);
	};
	// For change the data and title between components
	const setDrawerInfoHandler = (drawerTitle: any) => {
		setDrawerInfo({ drawerTitle });
	};

	// For fetch the all permission of some role
	const fetchRolePermissions = async (permissionDetails: any) => {
		setSelectedRole(permissionDetails);

		try {
			const permissions = await getApi(
				`/permission/${permissionDetails.id}`
			);
			setPermissions(permissions?.data.data);
		} catch (err) {
			//error
		}
	};

	const fetchRoles = async () => {
		setIsLoading(true);
		try {
			const roles = await getApi('/role', {});
			setRoles(roles.data.data);
		} catch (err) {
			toastText('Something went wrong in fetching roles', 'error');
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchRoles();
	}, []);

	return (
		<>
			<div className={styles['role-table']}>
				<TableActionHeader title={'Roles'}>
					<div className={styles['role-table__action']}></div>
				</TableActionHeader>
				<div>
					<DynamicTable
						roleDataSource={roles}
						setDrawerInfoHandler={setDrawerInfoHandler}
						openPermissionsHandler={openPermissionsHandler}
						fetchRolePermissions={fetchRolePermissions}
						isLoading={isLoading}
					/>
				</div>
			</div>

			{isPermissionDrawerOpen && (
				<SideDrawerWrapper
					isOpen={drawerAnimation}
					removeDrawerFromDom={removeDrawerFromDom}
					closeDrawerByAnimation={closeDrawerByAnimation}
					headerTitle={drawerInfo.drawerTitle}
					position="right"
					width="half"
				>
					<PermissionBody
						closeDrawerByAnimation={closeDrawerByAnimation}
						permissions={permissions}
						selectedRole={selectedRole}
						isLoading={!permissions?.length}
					/>
				</SideDrawerWrapper>
			)}
		</>
	);
};

export default RoleTable;
